// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as PositionCircle from "common/src/components/PositionCircle.bs.js";

function PlChartPosCircle(Props) {
  var sizeOpt = Props.size;
  var pl = Props.pl;
  var size = sizeOpt !== undefined ? sizeOpt : 30;
  var c = PositionCircle.placeColor(pl);
  return React.createElement(React.Fragment, undefined, React.createElement("text", {
                  fill: "#" + c,
                  fontFamily: "Merienda",
                  fontSize: "16",
                  textAnchor: "middle",
                  x: String(size / 2 | 0),
                  y: String(size - 6 | 0)
                }, String(pl)));
}

var make = PlChartPosCircle;

export {
  make ,
  
}
/* react Not a pure module */
